module.exports = __webpack_public_path__ + "static/media/roberto2.37e63f3e.jpg";